import React from "react";
import { subjectCropClipPath } from "../../../../components/objectTransform/objectTransformMath";
import "../../../../components/objectTransform/ObjectTransformChrome.css";

/**
 * Match CanvasEditor subject wrapper:
 * - While edge-cropping: overflow visible so the ghost can paint outside the box
 * - Idle: keep caller overflow (e.g. visible for drop-shadow) or hidden
 */
export function subjectWrapperStyleForCrop(wrapperStyle, isCropping) {
  if (!wrapperStyle) return wrapperStyle;
  return {
    ...wrapperStyle,
    overflow: isCropping ? "visible" : wrapperStyle.overflow ?? "hidden",
  };
}

/**
 * Match CanvasEditor main subject image:
 * Always clip to crop when a crop exists (post-release stays clean).
 * Ghost layer (separate) paints the faded outside only while isCropping.
 */
export function subjectMainImageStyleForCrop(
  imageStyle,
  { crop, originalImageSize, object }
) {
  if (!object || !(object.width > 0) || !(object.height > 0)) {
    return imageStyle;
  }
  const clipPath = subjectCropClipPath(crop, originalImageSize, {
    width: object.width,
    height: object.height,
  });
  if (!clipPath || clipPath === "none") {
    return imageStyle;
  }
  return {
    ...imageStyle,
    clipPath,
  };
}

/** Editor-style faded crop overflow — only while holding an edge handle. */
export function ToolPrepSubjectCropGhost({ active = false, src = null, style = null }) {
  if (!active || !src) return null;
  return (
    <img
      src={src}
      alt=""
      className="subject-crop-ghost"
      style={style}
      draggable={false}
    />
  );
}

export default ToolPrepSubjectCropGhost;
